<template>
  <span class="cancel-btn">
    <span
      :class="{ disabled: !orderCanBeCanceled }"
      class="cancel"
      @click.prevent.stop="checkTradeAuthAndConfirm"
    >
      <icon name="delete" />
      <span>{{ $t('trade.order-recall') }}</span>
    </span>
    <order-confirm
      :order="order"
      type="cancel"
      :visible="showConfirmPopup"
      @closeConfirm="closeConfirm"
    />
    <trade-password v-if="showTradePassword" @close="closeTradePassword" />
  </span>
</template>
<script>
import Notification from 'com/Notification'
import Icon from 'com/Icon'
import OrderConfirm from 'mod/TradeDialogs/OrderConfirm'
import TradePassword from 'mod/TradeDialogs/TradePassword'
import { mapGetters } from 'vuex'
import { SEC_TYPE } from 'const/stock'
import { ORDER_STATUS, OMNIBUS_ORDER_STATUS } from 'const/trade'
import { getOrderOperationTips } from 'utils/getOrderNotifyMsg'

export default {
  data() {
    return {
      showConfirmPopup: false,
      cancelConfirmed: false,
      showTradePassword: false
    }
  },
  components: {
    Icon,
    OrderConfirm,
    TradePassword
  },
  props: {
    order: {
      required: true
    }
  },
  computed: {
    ...mapGetters(['hasValidTradeToken', 'isVirtual', 'isIb']),
    orderCanBeCanceled() {
      if (this.isIb) {
        return [
          ORDER_STATUS.NO_RESULT,
          ORDER_STATUS.PRE_SUBMIT,
          ORDER_STATUS.SUBMITTED,
          ORDER_STATUS.PENDING_SUBMIT
        ].includes(this.order.status)
      } else {
        return [
          OMNIBUS_ORDER_STATUS.PENDING_NEW,
          OMNIBUS_ORDER_STATUS.NEW
        ].includes(this.order.status)
      }
    },
    isOption() {
      return this.order.secType === SEC_TYPE.OPT
    }
  },
  methods: {
    checkTradeAuthAndConfirm() {
      if (!this.orderCanBeCanceled) return
      if (!this.hasValidTradeToken && !this.isVirtual) {
        this.showTradePassword = true
      } else {
        this.confirm()
      }
    },
    closeTradePassword(success) {
      this.showTradePassword = false
      if (success) {
        this.confirm()
      }
    },
    confirm() {
      this.showConfirmPopup = true
    },
    closeConfirm(cancelConfirmed) {
      this.showConfirmPopup = false
      if (cancelConfirmed) {
        this.cancelConfirmed = true
        this.cancelOrder()
      }
    },
    cancelOrder() {
      // 模拟账户可能没有orderId，使用 id 字段代替
      return this.$store
        .dispatch('cancelOrder', this.order.orderId || this.order.id)
        .then(() => {
          this.cancelConfirmed = false
          this.$emit('orderCanceled')
        })
        .catch(error => {
          if (error.isNeedReOrder) {
            this.showTradePassword = true
          } else {
            this.notify(false)
          }
        })
    },
    notify(isSuccess) {
      const data = getOrderOperationTips(this.order, 'cancel', isSuccess)
      Notification.open(data)
    }
  },
  watch: {
    'order.originSymbol'() {
      this.cancelConfirmed = false
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';
.cancel-btn {
  .cancel {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
  }
  .disabled {
    color: @light-grey;
    cursor: default;
  }
}
</style>
